import WriteToLog from "./WriteToLog";   

/**
 * Calculate Systolic blood pressure < 5th percentile
 * @param {*} systolicbp Systolic Blood Pressure of the patient
 * @param {*} age_in_days
 * @returns 
 */
async function calculateSystolicBPRate(systolicbp, age_in_days) {
  let shockSystolicBPRisk = "none";
  var BPmax = "";

  try {
    if (age_in_days >= 0 && age_in_days <= 28) {
      BPmax = 60;
    } else if (age_in_days >= 29 && age_in_days < 365) {
      BPmax = 70;
    } else if (age_in_days >= 365 && age_in_days < 730) {
      BPmax = 72;
    } else if (age_in_days >= 730 && age_in_days < 1095) {
      BPmax = 74;
    } else if (age_in_days >= 1095 && age_in_days < 1460) {
      BPmax = 76;
    } else if (age_in_days >= 1460 && age_in_days < 1825) {
      BPmax = 78;
    } else if (age_in_days >= 1825 && age_in_days < 2190) {
      BPmax = 80;
    } else if (age_in_days >= 2190 && age_in_days < 2555) {
      BPmax = 82;
    } else if (age_in_days >= 2555 && age_in_days < 2920) {
      BPmax = 84;
    } else if (age_in_days >= 2920 && age_in_days < 3285) {
      BPmax = 86;
    } else if (age_in_days >= 3285 && age_in_days < 3650) {
      BPmax = 88;
    } else if (age_in_days >= 3650 && age_in_days < 4015) {
      BPmax = 90;
    } else if (age_in_days >= 4015 && age_in_days < 4380) {
      BPmax = 92;
    } else if (age_in_days >= 4380) {
      BPmax = 100;
    }

    if (BPmax !== "") {
      //var systolicbp_number = systolicbp.replace("mm[Hg]","");
      WriteToLog("BPmax: " + BPmax + " --- Patient BP: " + systolicbp);
      if (systolicbp <= BPmax) {
        shockSystolicBPRisk = "yes";
      }
    }
    WriteToLog("Inside calculateShockSystolicBPRate: " + shockSystolicBPRisk);
    return shockSystolicBPRisk;
  } catch (error) {
    if (error.response) {
      WriteToLog("calculateSystolicBPRate error.response: " + JSON.stringify(error.response.status));
    } else if (error.request) {
      WriteToLog("calculateSystolicBPRate error.request: " + error.request);
    } else {
      WriteToLog('calculateSystolicBPRate Error ', error.message);
    }
    return shockSystolicBPRisk;  
  }  
}

export default calculateSystolicBPRate;
